import React from "react";
import { Link } from "react-router-dom";

import PERFIL_DEFAULT from "../../../assets/img/blog/photo_perfil.jpg";

const MiniCardUser = () => {
	return (
		<aside className="mini-card-user">
			<img src={PERFIL_DEFAULT} alt=" perfil user" className="mini-card-user__photo" />
			<h3 className="mini-card-user__name">Name</h3>
			<p className="mini-card-user__description">
				Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa modi necessitatibus vel enim, earum saepe eius
				magni quae reiciendis corporis.
			</p>
			<Link to="/" className="btn fill green mini-card-user__btn">
				About
			</Link>
		</aside>
	);
};

export default MiniCardUser;
